module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extracts/components/extracts-dashboard.component.scss
// module id = ./src/app/extracts/components/extracts-dashboard.component.scss
// module chunks = main